import React from 'react';

export const DrawArrow = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 39.97">
            <path d="M1.01.98c.33-.33.66-.49 1.15-.82h.16c.16 0 .33-.16.49-.16h18.52c2.13 0 3.93 1.8 3.93 3.93s-1.8 3.93-3.93 3.93H13.3l25.55 25.39c.82.82 1.15 1.8 1.15 2.78s-.49 2.13-1.15 2.78c-.82.82-1.8 1.15-2.78 1.15s-2.13-.49-2.78-1.15L7.89 13.43v8.03c0 2.13-1.8 3.93-3.93 3.93-.98 0-1.97-.33-2.78-1.15S.03 22.44.03 21.46V3.93C-.13 2.78.36 1.8 1.01.98Z" />
        </svg>
    );
}
